import { render, staticRenderFns } from "./CategoryManagementView.vue?vue&type=template&id=2fd50d8f&scoped=true"
import script from "./CategoryManagementView.vue?vue&type=script&lang=js"
export * from "./CategoryManagementView.vue?vue&type=script&lang=js"
import style0 from "./CategoryManagementView.vue?vue&type=style&index=0&id=2fd50d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd50d8f",
  null
  
)

export default component.exports